// extracted by mini-css-extract-plugin
module.exports = {"container":"navbar_container__2EY4M","icons":"navbar_icons__mp8fI"};